import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExternalAuditsEmptyState = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 677,
	height: 408.333,
	viewBox: "0 0 677 408.333",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "external-audit-empty-state-clip-path",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_14904",
			"data-name": "Rectangle 14904",
			width: 677,
			height: 408.333,
			fill: "none"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "external-audit-empty-state-clip-path-2",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_14905",
			"data-name": "Rectangle 14905",
			width: 599.402,
			height: 366.367,
			fill: "none"
		})
	})] }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_12103",
		"data-name": "Group 12103",
		transform: "translate(50)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_9409",
			"data-name": "Group 9409",
			transform: "translate(-50)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group_9408",
				"data-name": "Group 9408",
				clipPath: "url(#external-audit-empty-state-clip-path)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_25045",
					"data-name": "Path 25045",
					d: "M298.907,501.767c-19.08.076-38.16.693-57.206,3.538-7.181,1.073-14.212,3.432-21.41,4.384-14.377,1.9-28.5,5.448-42.925,7.083-11.619,1.318-23.286,2.1-34.871,3.767a91.841,91.841,0,0,1-33.664-1.383c-7.979-1.917-15.995-3-23.84-6.074-8.775-3.444-18.31-5.905-27.454-5.817-13.039.126-25.736.141-38.214,6.222-4.38,2.134-9.743,5.644-13.069,10.123-7.615,10.255-8.645,35.841-1.042,46.476,12.805,17.9,40.136,24.923,58.085,25.255,19.669.364,38.777-1.6,58.475-2.75,18.3-1.072,36.561-2.6,54.9-2.542,37.445.11,74.894,0,112.272-3.359,35.117-3.156,70.322-2.072,105.515-2.072,36.09,0,71.935.381,107.765,6.822,15.611,2.807,31.515,3.789,47.205,5.755,14.051,1.761,27.554-.035,41.55-1.662a80.262,80.262,0,0,0,34.1-12.273c8.451-5.424,23.517-22.275,26.109-35.223,7.266-36.3-102.4-35.426-119.234-35.344-18.836.092-37.821.923-56.642-.041-7.917-.405-15.717-2.483-23.444-4.761-7.7-2.268-15.451-1.692-23.255-2.645-32.548-3.975-65.168-3.394-97.818-3.394-10.625,0-21.256-.125-31.886-.083",
					transform: "translate(16.015 -199.188)",
					fill: "#d3d8fc"
				})
			})
		}), /* @__PURE__ */ _jsx("g", {
			id: "Group_9411",
			"data-name": "Group 9411",
			transform: "translate(-10.409)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group_9410",
				"data-name": "Group 9410",
				clipPath: "url(#external-audit-empty-state-clip-path-2)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25046",
						"data-name": "Path 25046",
						d: "M263.3,108.925l3.418-2.892,4.428,1.413,2.54,3.7-1.159,3.157-3.6,2.085,1.365.364-.25,1.113-5.647,2.573c-1.358-1.415-5.936-2.5-6.663-3.26l3.777-3.245Z",
						transform: "translate(-102.316 -42.093)",
						fill: "#aa6755"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25047",
						"data-name": "Path 25047",
						d: "M82.169,541.65l-.132,1.29-.439,4.281,8.529,5.2,4.923-3.82-4.045-4.743-.376-.23-.2.493Z",
						transform: "translate(-32.393 -215.024)",
						fill: "#4b505b"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25048",
						"data-name": "Path 25048",
						d: "M117.755,388.714c-9.666.635-18.636.9-25.683.991l.251,33.05L81.782,480.8l.461.138,8.26,2.475.2-.493,27.7-68.433.967-13.952Z",
						transform: "translate(-32.466 -154.312)",
						fill: "#bcbec0"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25049",
						"data-name": "Path 25049",
						d: "M144.608,391.292l-.5,7.16,2.476,18.142,2.822,65.478h.048l.036-.947,8.429.257,13.3-69.516.717-28.4c-9.139,1.458-18.721,2.421-27.767,3.051Z",
						transform: "translate(-57.21 -152.228)",
						fill: "#bcbec0"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25050",
						"data-name": "Path 25050",
						d: "M161.941,545.692l-.581-.018-8.429-.257-.036.947-.125,3.355,8.85,4.576,4.666-4.164Z",
						transform: "translate(-60.646 -216.52)",
						fill: "#4b505b"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25051",
						"data-name": "Path 25051",
						d: "M103.032,130.691l-.844-2.135c.021-.016.043-.031.065-.046,3.736-2.833,5.442-7.767,5.238-12.43a24.822,24.822,0,0,0-2.2-8.791,19.442,19.442,0,0,0-3.406-4.335c-2.4-2.279-5.66-4.09-8.839-3.979-1.292.045-.754,1.053-2.317.257a2.786,2.786,0,0,1-.709-.6c-.229.251-.387.428-.431.473-1.5,1.561-3.159,2.307-4.96,3.439a8.647,8.647,0,0,0-3.548,8.812c.271,1.424.87,2.891.526,4.256-.3,1.192-1.253,2.014-1.86,3.049a5.5,5.5,0,0,0-.678,2.009c2.991,5.434,8.668,9.806,14.509,10.343,0,.021.01.043.014.064.078.346.159.69.254,1.028.428,1.5,1.447,3.079,3.007,3.191a4.735,4.735,0,0,0,2.068-.49l4.013-1.622a1.09,1.09,0,0,0,.679-.525,1.07,1.07,0,0,0-.1-.749l-.48-1.214",
						transform: "translate(-31.389 -39.154)",
						fill: "#aa6755"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25052",
						"data-name": "Path 25052",
						d: "M109.97,83.7c-3.163-.19-5.958,1.661-8.53,3.446-.458-3.111-3.45-5.255-6.322-6.094s-5.894-.835-8.7-1.933c-3.375-1.321-6.709-4.239-10.06-3.288-3.017.856-4.9,4.524-6.776,7.781-.049-.052-.1-.106-.148-.157a15.145,15.145,0,0,0-4.879-3.71c-6.018-2.487-5.326,5.024-9.952,4.626-1.116-.1-2.06-.979-3.112-1.443-1.989-.876-4.2-.182-5.982.9s-3.349,2.545-5.263,3.353c-1.7.718-3.623.9-5.208,1.847-2.381,1.429-1.893,4.013-2.316,6.369-.469,2.607-1.186,6.12-2.6,8.285-1.016,1.56-2.588,2.578-3.906,3.851a6.018,6.018,0,0,0-2.171,5c.267,1.846,1.731,3.345,2.152,5.169.577,2.726.279,4.2,1.495,6.9a8.587,8.587,0,0,0,2.542,3.719c1.612,1.118,3.666.825,5.434.289s3.571-1.277,5.43-.913c4.029.79,3.808,4.772,5.256,7.9a9.556,9.556,0,0,0,4.669,4.587,8.743,8.743,0,0,0,7.88-.028c3.556-1.983,5.169-6.6,4.45-10.85a32.893,32.893,0,0,0-1.388-4.441,11.586,11.586,0,0,1-.423-1.707c-.326-2.058.477-5.072-1.616-6.467a15.129,15.129,0,0,1-1.595-.876,3.051,3.051,0,0,1-.807-1.271,6.14,6.14,0,0,1-.316-3,5.5,5.5,0,0,1,.678-2.009c.606-1.034,1.56-1.857,1.86-3.049.344-1.365-.256-2.832-.526-4.256a8.647,8.647,0,0,1,3.548-8.812c1.8-1.132,3.459-1.878,4.959-3.439.044-.045.2-.222.431-.473a2.786,2.786,0,0,0,.709.6c1.562.8,1.025-.212,2.317-.257,3.179-.11,6.434,1.7,8.839,3.979a19.457,19.457,0,0,1,3.406,4.335,20.161,20.161,0,0,1,2.749,9.408c.147,4.674-2.276,6.735-.051,11.445a16.651,16.651,0,0,0,1.8,2.956,15.26,15.26,0,0,0,7.375,5.375c.327,0,.651-.014.974-.04a12.435,12.435,0,0,0,4.628-1.319,13.852,13.852,0,0,0,7.253-9.5c.281-1.371.416-2.888,1.316-3.88.725-.8,1.831-1.107,2.574-1.886,3.086-3.244-2.8-9.132-1.479-13.589.838-2.818,4.3-3.917,5.058-6.767.842-3.183-2.5-6.476-5.658-6.666",
						transform: "translate(-9.529 -30.027)",
						fill: "#3b455a"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25053",
						"data-name": "Path 25053",
						d: "M193.058,124.878c-1.034-.188-11.781-3.236-11.784-3.236.631.1-25.914,19.585-28.428,21.1-7.717,4.656-22.315-1.026-31.378-1.415a13.691,13.691,0,0,1-3.856,2.921,12.434,12.434,0,0,1-4.628,1.319c-.323.026-.648.041-.974.04a15.259,15.259,0,0,1-7.376-5.375c-1.107-.258-1.991-.446-2.586-.575l-4.171.169.481,1.214a1.073,1.073,0,0,1,.1.749,1.086,1.086,0,0,1-.679.525l-4.013,1.622a4.735,4.735,0,0,1-2.068.49c-1.561-.112-2.579-1.694-3.007-3.191-.1-.337-.177-.681-.255-1.028l-7.916.321-1.85,2.59a32.874,32.874,0,0,1,1.388,4.441c.719,4.253-.894,8.866-4.45,10.85a8.743,8.743,0,0,1-7.88.028l-1.645,92.907,7.769,35.075s5.586.153,14.225.039c6.666-.089,15.149-.337,24.291-.938q.79-.052,1.585-.107c8.556-.6,17.618-1.507,26.262-2.886,3.332-.532,6.6-1.132,9.755-1.812,0,0,8.111-22.04-3.543-77.345-1.831-8.69-4.364-18.454-6.823-27.1,7.769-6.665,28.586-18.187,35.386-25.839,7.449-8.382,18.135-25.539,18.37-25.5l-.3-.055",
						transform: "translate(-26.234 -48.289)",
						fill: "#587bc9"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25054",
						"data-name": "Path 25054",
						d: "M794.988,129.282l-18.441,3.249-32.7,25.327-43.66-11.4-5.058,10.492,40.592,19.534,17.685,4.461,22.978-7.5Z",
						transform: "translate(-275.952 -51.322)",
						fill: "#f2f2f2"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25055",
						"data-name": "Path 25055",
						d: "M689.046,163.192l-6.83,3.418-4.88-.552-.03-1.666,2.862-1.141-9.263-2.009-.85-4.47,11.1-2.638,10.06,2.93Z",
						transform: "translate(-265.998 -61.188)",
						fill: "#eac1a4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25056",
						"data-name": "Path 25056",
						d: "M819.28,528.417l-8.61,6.1-2.87,4.664a33.468,33.468,0,0,0,5.022,1.793c1.794.359,15.787-1.793,15.787-1.793v-8.252Z",
						transform: "translate(-320.68 -209.771)",
						fill: "#182975"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25057",
						"data-name": "Path 25057",
						d: "M935.065,529.612l-3.178,5.78s-1.988,7.3-.265,6.8,11.325-2.17,11.714-3.4,4.556-6.18,5.045-7.07-1.585-6.838-1.585-6.838Z",
						transform: "translate(-369.556 -208.368)",
						fill: "#182975"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25058",
						"data-name": "Path 25058",
						d: "M840.13,302.8l27.8,83,31.09,53.034,12.059-3.5-20.613-60.487s-2.489-60.762-6.56-78.634Z",
						transform: "translate(-333.514 -117.589)",
						fill: "#40495f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25059",
						"data-name": "Path 25059",
						d: "M803.634,309.012,814.4,432.435h12.917l3.947-63.147,7.414-55.907-28.224-33.073Z",
						transform: "translate(-319.026 -111.277)",
						fill: "#40495f"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25060",
						"data-name": "Path 25060",
						d: "M800.748,169.741c1.337-6.361,1.863-13.209,5.014-19.139s9.1-10.424,13.7-15.467c1.946-2.136,4.023-4.36,6.917-5.379a20.613,20.613,0,0,1,6.306-.815l19.437-.49a17.807,17.807,0,0,1,6.972.75c3.227,1.279,5.05,4.251,6.645,7.024,4.072,7.081,4.824,14.936,5.188,22.94-.012.075,5.055,100.531,1.036,98.645a60.691,60.691,0,0,0-16.345-4.471,180.736,180.736,0,0,0-24.069-2.274l-14.2.958h-8.571c-5.144.5-4.722,2.046-10.009,1.724-3.383-.205.454-76.716,1.986-84.007",
						transform: "translate(-316.555 -50.982)",
						fill: "#f2f2f2"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25061",
						"data-name": "Path 25061",
						d: "M857.123,112.162l9.646-.419a48.173,48.173,0,0,0-.1-7.692c2.718-.789,5.876-2.024,6.495-4.785a7.963,7.963,0,0,0-.01-2.661q-.638-5.49-1.276-10.98a9.749,9.749,0,0,0-.928-3.681c-1.092-1.951-3.369-2.9-5.547-3.409-5.56-1.286-11.745-.409-16.3,3.026a8.721,8.721,0,0,0-2.916,3.432c-.909,2.158-.455,4.619.013,6.913q.649,3.177,1.3,6.353c.5,2.436,1.256,5.216,3.519,6.244,1.2.546,2.659.487,3.732,1.256,1.892,1.356,1.466,4.257,2.37,6.4",
						transform: "translate(-335.713 -30.954)",
						fill: "#eac1a4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25062",
						"data-name": "Path 25062",
						d: "M831.232,53.655a9.383,9.383,0,0,0,2.18-.6c2.329-1.013,3.962-3.046,6.435-4a22.655,22.655,0,0,1,16.192.423c4.7,1.977,11.122,2.739,15.331,5.4a12.835,12.835,0,0,1,4.149,4.572,19.336,19.336,0,0,1-1.079,20.419,27.667,27.667,0,0,1-3.214,3.621c-2.4,2.329-5.276,5.211-8.44,5.948.08-2.79,3.1-11.433,1.093-13.834-2.669-3.185-7.907-3.1-11.661-2.752-4.473.418-8.155-1.017-12.616-.795-2.272.115-4.841.57-6.583-.892-2.014-1.691-6.272-7.063-7.282-9.42a5.956,5.956,0,0,1,1.242-6.244c1.326-1.413,2.758-1.577,4.253-1.844",
						transform: "translate(-327.636 -18.96)",
						fill: "#3b455a"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25063",
						"data-name": "Path 25063",
						d: "M843.15,199.945l-8.163,10.1-4.113-12.08a7.588,7.588,0,0,1,.569-2.9c1.7-4.121,19.619-55.731,19.619-55.731a49.637,49.637,0,0,0,1.058-5.025l5.74-.359-.944,5.863-2.69,2.308Z",
						transform: "translate(-329.84 -53.173)",
						fill: "#182975"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25064",
						"data-name": "Path 25064",
						d: "M425.313,35.415c-4.541-7.717-12.8-6.766-19.476-2.6a4.829,4.829,0,0,1-6.958-2.118V.048h-.415l-.034.015a167.065,167.065,0,0,0-137.366,79.49l22.288,12.868a19.573,19.573,0,0,1,4.9-10.2,16.452,16.452,0,0,1,12.065-4.94A18.917,18.917,0,0,1,319.124,96.4c-.157,6.135-3.371,10.064-6.786,12.761l21.439,12.378a83.219,83.219,0,0,1,64.638-37.507l.049.028h.415V53.79a4.829,4.829,0,0,1,6.8-2.22c4.7,2.68,9.321,5.017,14.57,2.164a13.486,13.486,0,0,0,5.066-18.319",
						transform: "translate(-103.637 -0.019)",
						fill: "#8a98f2"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25065",
						"data-name": "Path 25065",
						d: "M283.994,136.568c-8.954.074-12.259,7.7-11.992,15.566a4.829,4.829,0,0,1-5.313,4.966l-26.541-15.324-.207.359,0,.037a167.069,167.069,0,0,0,.158,158.708l22.288-12.868a19.569,19.569,0,0,1-6.388-9.346,16.448,16.448,0,0,1,1.754-12.918,18.917,18.917,0,0,1,25.962-6.729c5.234,3.2,7.03,7.951,7.658,12.257L312.807,258.9a83.22,83.22,0,0,1-.163-74.732l.049-.028.207-.359-26.21-15.132a4.828,4.828,0,0,1,1.476-7c4.669-2.727,9.005-5.564,9.159-11.536a13.486,13.486,0,0,0-13.332-13.546",
						transform: "translate(-87.322 -54.214)",
						fill: "#d7e8f4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25066",
						"data-name": "Path 25066",
						d: "M278.472,350.664c-4.413,7.792.539,14.467,7.485,18.168a4.829,4.829,0,0,1,1.644,7.084L261.06,391.24l.207.359.03.022a167.065,167.065,0,0,0,137.524,79.216V445.1a19.573,19.573,0,0,1-11.287.86,16.448,16.448,0,0,1-10.31-7.978,18.917,18.917,0,0,1,7.154-25.848c5.392-2.931,10.4-2.112,14.444-.5V386.878a83.219,83.219,0,0,1-64.8-37.225V349.6l-.207-.359L307.6,364.369a4.828,4.828,0,0,1-5.321-4.777c-.027-5.407-.315-10.581-5.411-13.7a13.486,13.486,0,0,0-18.4,4.772",
						transform: "translate(-103.635 -136.577)",
						fill: "#587bc9"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25067",
						"data-name": "Path 25067",
						d: "M459.872,438.92c4.541,7.717,12.8,6.766,19.476,2.6a4.829,4.829,0,0,1,6.958,2.118v30.647h.415l.034-.015a167.065,167.065,0,0,0,137.365-79.49l-22.288-12.868a19.574,19.574,0,0,1-4.9,10.2,16.45,16.45,0,0,1-12.064,4.94,18.916,18.916,0,0,1-18.809-19.119c.157-6.135,3.371-10.064,6.786-12.76L551.407,352.8a83.217,83.217,0,0,1-64.638,37.507l-.049-.028h-.415v30.265a4.829,4.829,0,0,1-6.8,2.22c-4.7-2.68-9.321-5.017-14.57-2.164a13.485,13.485,0,0,0-5.066,18.319",
						transform: "translate(-181.867 -140.055)",
						fill: "#8a98f2"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25068",
						"data-name": "Path 25068",
						d: "M649.284,309.573c8.954-.074,12.259-7.7,11.992-15.566a4.829,4.829,0,0,1,5.313-4.966l26.541,15.324.207-.359,0-.037a167.067,167.067,0,0,0-.158-158.708L670.9,158.129a19.572,19.572,0,0,1,6.388,9.346,16.448,16.448,0,0,1-1.754,12.918,18.917,18.917,0,0,1-25.963,6.729c-5.234-3.2-7.03-7.951-7.658-12.257l-21.439,12.377a83.22,83.22,0,0,1,.163,74.732l-.049.028-.207.359,26.21,15.132a4.828,4.828,0,0,1-1.476,7c-4.669,2.727-9.005,5.564-9.159,11.536a13.485,13.485,0,0,0,13.332,13.546",
						transform: "translate(-246.277 -57.666)",
						fill: "#d7e8f4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25069",
						"data-name": "Path 25069",
						d: "M625.3,120.174c4.413-7.792-.539-14.467-7.485-18.168a4.829,4.829,0,0,1-1.645-7.084L642.708,79.6l-.207-.359-.03-.022A167.064,167.064,0,0,0,504.947,0V25.736a19.574,19.574,0,0,1,11.287-.86,16.446,16.446,0,0,1,10.311,7.978A18.917,18.917,0,0,1,519.392,58.7c-5.392,2.931-10.4,2.112-14.444.5V83.96a83.219,83.219,0,0,1,64.8,37.225v.057l.207.359,26.21-15.132a4.828,4.828,0,0,1,5.321,4.777c.027,5.407.315,10.581,5.411,13.7a13.486,13.486,0,0,0,18.4-4.772",
						transform: "translate(-200.454)",
						fill: "#182975"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25070",
						"data-name": "Path 25070",
						d: "M838.29,168.166,839.373,204l-51.135,11.073,2.293,11.611,56.567-3.52,10.476-9.77,7.025-34.413Z",
						transform: "translate(-312.914 -66.758)",
						fill: "#f2f2f2"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25071",
						"data-name": "Path 25071",
						d: "M781.254,255.035l-7.569,4.347-8.295-4.021,8.239-13.128,5.538,2.238Z",
						transform: "translate(-303.844 -96.162)",
						fill: "#eac1a4"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25072",
						"data-name": "Path 25072",
						d: "M211.359,251.627,211.2,256.5l8.606,3.133,4.96-3.758,0-5.676-4.788-.267-.15-1.248-1.568-1.008Z",
						transform: "translate(-83.843 -98.323)",
						fill: "#aa6755"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_25073",
						"data-name": "Path 25073",
						d: "M163.211,236.36l26.553,5.251s-1.53,16.2-1.515,14.849-34.868-2.927-34.868-2.927Z",
						transform: "translate(-60.889 -93.83)",
						fill: "#587bc9"
					})
				]
			})
		})]
	})]
});
export default SvgExternalAuditsEmptyState;
